import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    marginTop: theme.spacing(4.125),
  },
  productImageName: {
    display: 'flex',
  },
  agreementInfo: {
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '0.875rem',
    marginBottom: theme.spacing(3),
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
      flexDirection: 'column',
    },
  },
  agreementRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    ['@media (max-width: 600px)']: {
      '&:first-of-type': {
        marginBottom: theme.spacing(3),
      },
    },
  },
  bold: {
    fontSize: '0.875rem',
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
  title: {
    fontSize: '0.875rem',
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
  agreementDescriptions: {
    display: 'flex',
    justifyContent: 'space-between',
    textAlign: 'left',
    ['@media (max-width: 600px)']: {
      flexDirection: 'column',
    },
  },
  agreementTitleValue: {
    display: 'flex',
    flexDirection: 'column',
    ['@media (max-width: 600px)']: {
      '&:first-of-type': {
        marginBottom: theme.spacing(3),
      },
    },
  },
  agreementTitle: {
    fontWeight: 600,
    fontSize: '0.875rem',
    whiteSpace: 'nowrap',
    color: theme.palette.primary.light,
    marginBottom: theme.spacing(0.625),
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
}))
